import { render, staticRenderFns } from "./SubLife.vue?vue&type=template&id=81d3d87e&"
import script from "./SubLife.vue?vue&type=script&lang=js&"
export * from "./SubLife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports